import { render, staticRenderFns } from "./Totem.vue?vue&type=template&id=76122788"
import script from "./Totem.vue?vue&type=script&lang=js"
export * from "./Totem.vue?vue&type=script&lang=js"
import style0 from "./Totem.vue?vue&type=style&index=0&id=76122788&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports